module.exports = __webpack_public_path__ + "media/images/emblems/Cote-aux-fees-c5db3c53323498c4cc034b11285a5670.png";